/**
 * usePrintBracket.js
 * Shared hook for loading all data needed to render BracketPrintView.
 */

import { useState, useCallback } from 'react';
import { useApi } from './useApi';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function usePrintBracket() {
  const api = useApi();

  const [printData, setPrintData]       = useState(null);
  const [printLoading, setPrintLoading] = useState(false);
  const [printError, setPrintError]     = useState('');

  const openPrint = useCallback(async (bracketId, bracketObj = null) => {
    setPrintLoading(true);
    setPrintError('');
    try {
      console.log('[PRINT] Starting fetch, bracketId=', bracketId, 'hasObj=', !!bracketObj);
      // Fetch everything in parallel — including branding fresh each time
      // so we always get the latest logoUrl regardless of hook load timing
      const [bracketData, scoresData, teamsData, wiringData, brandingData] = await Promise.all([
        bracketObj ? (console.log('[PRINT] using provided obj') || Promise.resolve(bracketObj)) : (console.log('[PRINT] fetching bracket') || api.getBracket(bracketId)),
        api.getScores().then(r => { console.log('[PRINT] scores ok', r?.length); return r; }).catch(e => { console.log('[PRINT] scores err', e.message); return []; }),
        api.getTeams().then(r => { console.log('[PRINT] teams ok', r?.teams?.length); return r; }).catch(e => { console.log('[PRINT] teams err', e.message); return { teams: [] }; }),
        fetch(API_BASE + '/wiring').then(r => r.json()).then(r => { console.log('[PRINT] wiring ok'); return r; }).catch(e => { console.log('[PRINT] wiring err', e.message); return null; }),
        fetch(API_BASE + '/branding').then(r => r.json()).then(r => { console.log('[PRINT] branding ok'); return r; }).catch(e => { console.log('[PRINT] branding err', e.message); return { logoUrl: null, poolName: 'March Madness Pool' }; }),
      ]);

      const teamsById = {};
      (teamsData?.teams || []).forEach(t => { teamsById[t.id] = t; });

      // Use scores endpoint for all games — covers all users including non-admin
      const games = Array.isArray(scoresData) ? scoresData : [];

      console.log('[PRINT] all fetched, setting data');
      setPrintData({
        bracket: bracketData,
        games,
        teamsById,
        wiring:   wiringData,
        branding: brandingData,   // always fresh from server
      });
    } catch (err) {
      console.log('[PRINT] caught error:', err.message);
      setPrintError(err.message || 'Failed to load bracket for printing');
    } finally {
      console.log('[PRINT] finally block');
      setPrintLoading(false);
    }
  }, [api]);

  const closePrint = useCallback(() => {
    setPrintData(null);
    setPrintError('');
  }, []);

  return { printData, printLoading, printError, openPrint, closePrint };
}
